export function getOperationType ({ operation, } = {}) {
  return operation
}
